import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErlenmeyerFlask = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 22,
	viewBox: "0 0 18 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2903 0.75V3.236C11.2903 4.984 11.2903 5.858 11.5053 6.697C11.7183 7.537 12.1383 8.307 12.9773 9.847L14.1133 11.935C16.2513 15.861 17.3203 17.825 16.4433 19.28L16.4293 19.302C15.5403 20.75 13.2763 20.75 8.75031 20.75C4.22431 20.75 1.96031 20.75 1.07031 19.302L1.05731 19.28C0.180313 17.825 1.24931 15.861 3.38731 11.935L4.52331 9.847C5.36331 8.307 5.78131 7.537 5.99531 6.697C6.20931 5.857 6.20931 4.984 6.20931 3.237V0.75",
			stroke: "#616161",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75 14.752L5.759 14.75M11.75 16.752L11.759 16.75",
			stroke: "#616161",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.75 0.75H12.75",
			stroke: "#616161",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 10.3061C5.25 9.15305 6.85 9.98405 8.75 11.0681C11.25 12.4941 12.75 11.4001 13.25 10.3651",
			stroke: "#616161",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgErlenmeyerFlask);
export { ForwardRef as ReactComponent };
